//@flow
import styled from "styled-components"
import theme from "../Theme"

const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 60rem;
  align-items: center;
  padding: 0.25rem 0;
`

FormRow.defaultProps = { theme }

export default FormRow



// WEBPACK FOOTER //
// ./src/UI/Form/FormRow.js